import { render, staticRenderFns } from "./SellerOfferCreateRTTRequestForm.vue?vue&type=template&id=645e4724&scoped=true"
import script from "./SellerOfferCreateRTTRequestForm.vue?vue&type=script&lang=js"
export * from "./SellerOfferCreateRTTRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645e4724",
  null
  
)

export default component.exports